import React from 'react';

import { useAppSelector } from '@fd/customHooks/useAppSelector';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import { getTranslate } from 'react-localize-redux';

import useSearchMenuItems from './customHooks/useSearchMenuItems';
import MobileSearchMenu from './MobileSearchMenu';
import SettingsSearchBar from './SettingsSearchBar';

const PortalSearch = React.memo(() => {
  const translate = useAppSelector((state) => getTranslate(state.locale));
  const { menuItems } = useSearchMenuItems();

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  if (isMobile) {
    return (
      <MobileSearchMenu
        menuItems={menuItems}
        placeholder={translate('Find_a_setting_or_a_page') as string}
        translate={translate}
      />
    );
  }

  return (
    <SettingsSearchBar
      menuItems={menuItems}
      placeholder={translate('Find_a_setting_or_a_page') as string}
    />
  );
});

export default PortalSearch;
